export const LIST_PRACTITIONERS = 'LIST_PRACTITIONERS';
export const LIST_PRACTITIONERS_SUCCESS = 'LIST_PRACTITIONERS_SUCCESS';
export const LIST_PRACTITIONERS_FAILED = 'LIST_PRACTITIONERS_FAILED';
